// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#base{display:flex;flex-direction:column;position:relative;width:350px}#base>identity-notification:not(:first-child){margin-top:8px}#base identity-notification{transition:opacity 200ms;opacity:1}#base identity-notification.fading{opacity:0}@media only screen and (max-width: 640px){#base{width:100vw;align-items:center}#base>identity-notification{width:calc(100% - 15px);max-width:400px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
